import NediEmptyState from '../nedi/NediEmptyState';

// Empty state compartilhado Atlas Vivo — chrome Nedi (panel radius + AvButton).
// API estável para Dia/Histórias/Dados/WorkspaceStatus.
function AtlasEmptyState(props) {
  return <NediEmptyState {...props} />;
}

export default AtlasEmptyState;
